import { useEffect } from 'react';
import { InlineSpinner } from '../../components/common/spinner';
import { keycloakConfig } from '../../contexts/auth-context';
import { PageHeader } from '../../components/modals/settings-modal/page-header';

export const ChangePassword = () => {
  const { url, realm, clientId, baseUrl } = keycloakConfig;

  useEffect(() => {
    const domainBaseUrl = window.location?.origin || baseUrl;
    const keycloakUrl = new URL(`${url}/realms/${realm}/protocol/openid-connect/auth`);
    keycloakUrl.searchParams.append('client_id', clientId);
    keycloakUrl.searchParams.append('redirect_uri', `${domainBaseUrl}/home`);
    keycloakUrl.searchParams.append('response_type', 'code');
    keycloakUrl.searchParams.append('scope', 'openid');
    keycloakUrl.searchParams.append('kc_action', 'UPDATE_PASSWORD');

    window.location.href = keycloakUrl.toString();
  }, [url, realm, clientId, baseUrl]);

  return (
    <div className="p-6">
      <PageHeader header="Change Password" />
      <div className="flex h-full w-full items-center justify-center py-12">
        <InlineSpinner />
      </div>
    </div>
  );
};
